import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcCheckSmallOl = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20.7098 6.29561C21.0988 6.68763 21.0964 7.32079 20.7044 7.70981L10.6275 17.7098C10.4387 17.8971 10.1832 18.0015 9.91729 18C9.65139 17.9984 9.39706 17.8911 9.21051 17.7016L4.28743 12.7016C3.89995 12.3081 3.90486 11.6749 4.2984 11.2874C4.69194 10.8999 5.32508 10.9049 5.71257 11.2984L9.93128 15.583L19.2956 6.29019C19.6876 5.90116 20.3208 5.90359 20.7098 6.29561Z",
		fill: "inherit"
	})
});
export default SvgIcCheckSmallOl;
